export default "__VITE_ASSET__CIXxQssi__"